import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-600">
          <div className="mb-2 sm:mb-0">
            © {new Date().getFullYear()} JSM L'Oréal. All rights reserved.
          </div>
          <div className="flex space-x-4">
            <Link
              to="/privacy-policy"
              className="hover:text-gray-900 transition-colors underline"
            >
              Privacy Policy
            </Link>
            <Link
              to="/support"
              className="hover:text-gray-900 transition-colors underline"
            >
              Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
